'use strict';

const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = createWidgetFactory({
    name: 'membership_cancel_account',

    viewClass: require('./view'),

    methods: {
        open() {
            this.open();
        },
    },
});
